import { Add } from "@mui/icons-material";
import { Button, darken, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { theme } from "~/config/theme";

import { GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment } from "./fragments.generated";

type GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButtonProps = {
    travelGroup: GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment;
    onClick: () => void;
    disabled: boolean;
};

export function GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButton({
    travelGroup,
    onClick,
    disabled,
}: GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButtonProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Button
            startIcon={<Add />}
            disabled={disabled}
            onClick={onClick}
            sx={{
                textTransform: "none",
                textAlign: "left",
                justifyContent: "start",

                borderRadius: 0,
                borderTop: `1px solid ${theme.palette.divider}`,
                color: theme.palette.primary.main,

                backgroundColor: theme.palette.background.default,
                "&:hover": {
                    backgroundColor: darken(theme.palette.background.default, 0.03),
                },
            }}
        >
            <Stack>
                <Typography>{t("addToVisitButton.addToCarpool")}</Typography>
                <Typography variant="caption">
                    {t("addToVisitButton.withPerson", {
                        personName: `${travelGroup.ownerPlannerShift?.fieldworker.user.firstName} ${travelGroup.ownerPlannerShift?.fieldworker.user.lastName}`,
                    })}
                </Typography>
            </Stack>
        </Button>
    );
}
